import { getRunStylesCount } from '../Runs/RunStyles';
import { getParagraphStylesCount } from '../Paragraphs/ParagraphStyles';

const getStylesCount = textBodyData => getRunStylesCount(textBodyData) + getParagraphStylesCount(textBodyData);

export default getStylesCount;
